import store from "@/store"

export default {
    get fields() {
        return store.state.field.fields
    },

    set fields(fields) {
        store.commit("field/updateFields", fields)
    },

    get fieldGroupRules() {
        return store.state.field.fieldGroupRules
    },

    set fieldGroupRules(rules) {
        store.commit("field/updateFieldGroupRules", rules)
    },

    cachedFields(providerKey, applyMode) {
        return store.getters["field/cachedFields"](providerKey, applyMode)
    }
}
